import t, { useState as _, useRef as x, useSyncExternalStore as B, useMemo as k, useEffect as C, useCallback as D } from "react";
import { c as o, t as S, D as p } from "./app-a75c1d35.mjs";
import { S as L, a as T } from "./swiper.min-13551361.mjs";
import { L as O } from "./Link-479ac100.mjs";
import { I } from "./Image-d6406817.mjs";
import { B as u } from "./Block-9b78bd10.mjs";
import { B as w } from "./Button-c598cb52.mjs";
import "./LinkContext-0c83848a.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./Icon-3122c134.mjs";
import "./useClickOutside-726e7c36.mjs";
const y = "card", A = "card__title", M = "card__image-container", R = "card--pressed", W = "desktop", G = "card__save-button", H = "card__info", z = "card__date", $ = "card__description", F = "card__description--hidden", r = {
  card: y,
  cardTitle: A,
  cardImageContainer: M,
  cardPressed: R,
  desktop: W,
  cardSaveButton: G,
  cardInfo: H,
  cardDate: z,
  cardDescription: $,
  cardDescriptionHidden: F
}, P = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
}, X = ({
  title: d,
  description: a,
  date: i,
  dateEnd: g,
  link: h,
  image: s = null,
  linkLocale: f,
  i18n: c = {}
}) => {
  const { date: m = "Date", startFrom: E = "Start from" } = c, [v, e] = _(!1), n = i?.toLocaleDateString("fi", P), N = g?.toLocaleDateString("fi", P), b = !N || N === n ? m : E;
  return /* @__PURE__ */ t.createElement(
    O,
    {
      "data-testid": "card",
      href: h,
      locale: f,
      disableLinkTextStyle: !0,
      className: o(r.card, v && r.cardPressed),
      onMouseDown: () => e(!0),
      onMouseUp: () => e(!1),
      onMouseLeave: () => e(!1)
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: o(r.cardImageContainer),
        "data-testid": "card-image",
        itemScope: !0,
        itemType: "https://schema.org/ImageObject"
      },
      s && /* @__PURE__ */ t.createElement(
        I,
        {
          credits: s.credits,
          src: s.src,
          width: s.width,
          height: s.height,
          altText: s.altText,
          imageLoader: s.imageLoader,
          styling: s.styling
        }
      )
    ),
    /* @__PURE__ */ t.createElement("div", { className: o(r.cardInfo), "data-testid": "card-content" }, i && /* @__PURE__ */ t.createElement("p", { className: o(r.cardDate, S.textsLeadText) }, /* @__PURE__ */ t.createElement("meta", { itemProp: "datePublished", content: i.toISOString() }), `${b} ${n}`), /* @__PURE__ */ t.createElement("div", { className: r.cardTitle }, /* @__PURE__ */ t.createElement("p", { className: S.textsComponentTitleBold, itemProp: "name" }, d)), /* @__PURE__ */ t.createElement(
      "p",
      {
        className: o(r.cardDescription, S.textsLeadText),
        itemProp: "description"
      },
      a
    ))
  );
}, j = "recommendations", U = "recommendations__slide", V = "desktop", q = "recommendations__block", J = "recommendations__header", K = "recommendations__title", Q = "recommendations__navigation", Y = "recommendations__separator", Z = "recommendations__contents", l = {
  recommendations: j,
  recommendationsSlide: U,
  desktop: V,
  recommendationsBlock: q,
  recommendationsHeader: J,
  recommendationsTitle: K,
  recommendationsNavigation: Q,
  recommendationsSeparator: Y,
  recommendationsContents: Z
}, ee = 1216;
function ge({ title: d, cards: a }) {
  const i = x(null), [g, h] = _(!0), [s, f] = _(!1), c = B(
    te,
    ne,
    () => 0
  ), m = k(() => c > p.xl, [c]);
  C(() => {
    const e = i.current;
    if (m && e) {
      const n = (c - ee) / 2;
      e.params.slidesOffsetBefore = n, e.params.slidesOffsetAfter = n, e.update();
    }
    e && a && (e.slideTo(0), f(!e.allowSlideNext || e.isEnd));
  }, [a, c, m]);
  const E = D(
    (e) => {
      if (h(e.isBeginning), m && a) {
        const n = a.length % 3 === 0 ? 3 : 2;
        f(
          e.snapIndex >= Math.trunc(a.length / n) - 1 || e.isEnd
        );
      } else
        f(e.isEnd);
    },
    [a, m]
  ), v = (e) => {
    const n = i.current;
    n && (e === "previous" ? n?.slidePrev() : n?.slideNext());
  };
  return /* @__PURE__ */ t.createElement(
    u,
    {
      "data-testid": "recommendations-block",
      topPadding: u.Padding.SMALL,
      bottomPadding: u.Padding.LARGE
    },
    /* @__PURE__ */ t.createElement(u.Content, { "data-testid": "recommendations-content" }, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: o(l.recommendationsHeader),
        "data-testid": "recommendations-header"
      },
      /* @__PURE__ */ t.createElement(
        "p",
        {
          className: o(
            l.recommendationsTitle,
            S.headingSection
          )
        },
        d
      ),
      !s || !g ? /* @__PURE__ */ t.createElement(
        "div",
        {
          className: o(l.recommendationsNavigation),
          "data-testid": "recommendations-navigation-container"
        },
        /* @__PURE__ */ t.createElement(
          w.Arrow,
          {
            disabled: g,
            arrowDirection: "left",
            "aria-label": "Previous slide",
            onClick: () => v("previous"),
            "data-testid": "prev"
          }
        ),
        /* @__PURE__ */ t.createElement("div", { className: o(l.recommendationsSeparator) }),
        /* @__PURE__ */ t.createElement(
          w.Arrow,
          {
            disabled: s,
            arrowDirection: "right",
            "aria-label": "Next slide",
            onClick: () => v("next"),
            "data-testid": "next"
          }
        )
      ) : null
    )),
    a && /* @__PURE__ */ t.createElement(u.Content, { limitedWidth: !1 }, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: o(l.recommendations),
        "data-testid": "recommendations-container"
      },
      /* @__PURE__ */ t.createElement(
        L,
        {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesPerGroup: 1,
          centeredSlides: !1,
          speed: 500,
          preventClicks: !1,
          preventClicksPropagation: !1,
          touchStartPreventDefault: !1,
          slidesOffsetAfter: 20,
          slidesOffsetBefore: 20,
          onSlideChange: E,
          onSwiper: (e) => {
            i.current = e;
          },
          breakpoints: {
            [p.sm]: {
              slidesPerGroup: 2,
              spaceBetween: 20,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [p.md]: {
              slidesPerGroup: 2,
              spaceBetween: 24,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [p.lg]: {
              slidesPerGroup: 3,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            [p.xl]: {
              slidesPerGroup: a.length < 6 ? a.length === 5 ? 2 : 1 : 3,
              spaceBetween: 32,
              slidesOffsetBefore: 112,
              slidesOffsetAfter: 112
            }
          }
        },
        a.map((e, n) => /* @__PURE__ */ t.createElement(
          T,
          {
            key: n,
            className: l.recommendationsSlide,
            "data-testid": "recommendation"
          },
          /* @__PURE__ */ t.createElement(X, { ...e })
        ))
      )
    ))
  );
}
function te(d) {
  return window.addEventListener("resize", d), () => window.removeEventListener("resize", d);
}
function ne() {
  return window.innerWidth;
}
export {
  ge as Recommendations
};
//# sourceMappingURL=Recommendations.js.map
